import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TimeHoldIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M11 4a7 7 0 000 14 1 1 0 110 2 9 9 0 110-18c4.195 0 7.717 2.87 8.716 6.75a1 1 0 11-1.937.5A7.003 7.003 0 0011 4z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M10.748 6a1 1 0 011 1v4.382l2.447 1.224a1 1 0 11-.894 1.788l-2.447-1.223a2 2 0 01-1.106-1.789V7a1 1 0 011-1zM19 13a3 3 0 00-3 3v1a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1v-4a1 1 0 00-1-1v-1a3 3 0 00-3-3zm1 4v-1a1 1 0 10-2 0v1h2z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        })
                    ]
                })
            })
        ]
    });
};
TimeHoldIcon.isCarinaIcon = true;
export default TimeHoldIcon;
